import { render, staticRenderFns } from "./extraElement.vue?vue&type=template&id=40ee06a8&scoped=true&"
import script from "./extraElement.vue?vue&type=script&lang=js&"
export * from "./extraElement.vue?vue&type=script&lang=js&"
import style0 from "./extraElement.vue?vue&type=style&index=0&id=40ee06a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee06a8",
  null
  
)

export default component.exports